import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Favicon from './assets/favicon.png';
import SeoPng from './assets/seo.png';

interface SEOProps {
  description: string;
  image?: string;
  title: string;
}

export const SEO = ({ title, description, image }: SEOProps) => {
  const { i18n } = useTranslation();

  return (
    <Helmet htmlAttributes={{ lang: i18n.language }}>
      <link rel="shortcut icon" href={Favicon} />
      <link rel="apple-touch-icon" href={Favicon} />

      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:locale" content="en_US" />
      <meta name="og:type" content="website" />
      <meta name="og:title" content={title} />
      <meta name="og:description" content={description} />
      <meta name="og:image" content={image || SeoPng} />
      <meta name="og:site_name" content="CureWiki" />
      <meta name="og:url" content={window.location.href} />
    </Helmet>
  );
};
